<template>
  <div>
    <div class="footer-box" v-if="!isPhone">
      <div class="left-box">
        <div class="cell-big-box">
          <div class="cell-box">
            <div class="title">产品</div>
            <!-- <div class="line"></div> -->
            <div class="text" @click="toUrl('/product/index?current=1','',1)">乘用车领域</div>
            <div class="text" @click="toUrl('/product/index?current=2','',2)">商用车领域</div>
            <div class="text" @click="toUrl('/product/index?current=3','',3)">
              农业领域
            </div>
            <div class="text" @click="toUrl('/product/index?current=4','',4)">工程机械领域</div>
            <div class="text" @click="toUrl('/product/index?current=5','',5)">船用领域</div>
            <div class="text" @click="toUrl('/product/index?current=6','',6)">储能领域</div>
            <div class="text" @click="toUrl('/product/index?current=7','',7)">铅酸动力</div>
          </div>
          <div class="cell-box">
            <div class="title">解决方案</div>
            <div class="text" @click="toUrl('/solution/e-commerce')">电商服务</div>
            <!-- <div class="text">车企服务</div> -->
            <div class="text" @click="toUrl('/solution/public-utilities')">公共事业</div>
            <!-- <div class="text" @click="toUrl('/solution/government')">政府机构</div> -->
          </div>
          <div class="cell-box">
            <div class="title">关于骆驼</div>
            <!-- <div class="line"></div> -->
            <div class="text" @click="toUrl('/brand-story/introduce')">
              品牌故事
            </div>
            <div class="text" @click="toUrl('/about-lt/brand-strength')">
              品牌实力
            </div>
            <div class="text" @click="toUrl('/about-lt/brand-technology')">
              品牌技术
            </div>
            <div class="text" @click="toUrl('/about-lt/battery-recycling')">
              回收业务
            </div>
            <!-- <div class="text">企业文化</div>
            <div class="text">社会责任</div> -->
          </div>
          <div class="cell-box">
            <div class="title">信息</div>
            <!-- <div class="line"></div> -->
            <div class="text" @click="toUrl('/info/battery-knowledge')">
              电池知识
            </div>
            <!-- <div class="text">常见问题</div>
            <div class="text">招商加盟</div> -->
            <div class="text" @click="toUrl('/download')">下载中心</div>
          </div>
          <div class="cell-box">
            <div class="title">联系我们</div>
            <!-- <div class="line"></div> -->
            <div class="text">服务热线：400-189-9507</div>
            <div class="text" @click="toUrl('','1')">骆驼集团官网</div>
          </div>
        </div>
        <div class="copy-right"><span>Copyright © 2016 骆驼集团股份有限公司 ALL RIGHTS RESERVED&nbsp;&nbsp;&nbsp;&nbsp;备案号：鄂ICP备15000576号-3&nbsp;&nbsp;&nbsp;&nbsp;<img class="" src="@/assets/footer/police-shield.webp" alt="">鄂公网安备 42060602000269号</span></div>
      </div>
      <div class="right-box">
        <div class="logo">
          <img src="@/assets/footer/logo.webp" alt="" />
        </div>
        <div class="card-box">
          <div class="img img1"></div>
          <div class="img img2"></div>
          <div class="img img3"></div>
          <div class="img img4"></div>
          <div class="img img5"></div>
          <div class="img-hover-box img-hover-box1">
            <img class="sanjiao" src="@/assets/footer/sanjiao.webp" alt="">
            <img class="code" src="@/assets/footer/code-1.webp" alt="">
          </div>
          <div class="img-hover-box img-hover-box2">
            <img class="sanjiao" src="@/assets/footer/sanjiao.webp" alt="">
            <img class="code" src="@/assets/footer/code-2.webp" alt="">
          </div>
          <div class="img-hover-box img-hover-box3">
            <img class="sanjiao" src="@/assets/footer/sanjiao.webp" alt="">
            <img class="code" src="@/assets/footer/code-3.webp" alt="">
          </div>
          <div class="img-hover-box img-hover-box4">
            <img class="sanjiao" src="@/assets/footer/sanjiao.webp" alt="">
            <img class="code" src="@/assets/footer/code-4.webp" alt="">
          </div>
          <div class="img-hover-box img-hover-box5">
            <img class="sanjiao" src="@/assets/footer/sanjiao.webp" alt="">
            <img class="code" src="@/assets/footer/code-5.webp" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="footer-box-app" :style="{
      paddingTop:pTop,
      backgroundColor:bgColor
    }">
      <div class="logo-box w-center">
        <img src="@/assets/nav/logo.webp" alt="">
      </div>
      <div class="copy-right">
        <div class="icon-box">
          <img class="icon icon1" src="@/assets/index/web/wx.webp" alt="">
          <img class="icon icon2" src="@/assets/index/web/wb.webp" alt="">
          <img class="icon icon3" src="@/assets/index/web/dy.webp" alt="">
          <img class="icon icon4" src="@/assets/index/web/ks.webp" alt="">
          <img class="icon icon5" src="@/assets/index/web/bibi.webp" alt="">

          <div class="img-hover-box img-hover-box1">
            <img class="sanjiao" src="@/assets/footer/sanjiao.webp" alt="">
            <img class="code" src="@/assets/footer/code-1.webp" alt="">
          </div>
          <div class="img-hover-box img-hover-box2">
            <img class="sanjiao" src="@/assets/footer/sanjiao.webp" alt="">
            <img class="code" src="@/assets/footer/code-2.webp" alt="">
          </div>
          <div class="img-hover-box img-hover-box3">
            <img class="sanjiao" src="@/assets/footer/sanjiao.webp" alt="">
            <img class="code" src="@/assets/footer/code-3.webp" alt="">
          </div>
          <div class="img-hover-box img-hover-box4">
            <img class="sanjiao" src="@/assets/footer/sanjiao.webp" alt="">
            <img class="code" src="@/assets/footer/code-4.webp" alt="">
          </div>
          <div class="img-hover-box img-hover-box5">
            <img class="sanjiao" src="@/assets/footer/sanjiao.webp" alt="">
            <img class="code" src="@/assets/footer/code-5.webp" alt="">
          </div>
        </div>
        <div class="phone">服务热线：<span>400-189-9507</span></div>
        <div class="text">Copyright © 2023 骆驼集团股份有限公司  ALL RIGHTS RESERVED</div>
        <div class="text">备案号：鄂ICP备15000576号-3</div>
        <div class="text w-center" style="line-height: normal;">
          <img class="" src="@/assets/footer/police-shield.webp" alt="">
          鄂公网安备 42060602000269号
        </div>
      </div>
    </div>
    <van-popup v-model="show">
      <img src="@/assets/footer/code-1.webp" alt="">
    </van-popup>
  </div>
</template>
<script>
export default {
  props:{
    pTop:{
      type:String,
      default:'0.5rem'
    },
    bgColor:{
      type:String,
      default:'#FFFFFF'
    }
  },
  data(){
    return {
      isPhone:false,
      show:false,
      active1:false,
    }
  },
  mounted(){
    this.isPhone = this.IsPhone();
  },
  methods: {
    toUrl(path, home,index) {
      if (!home) {
        this.$router.push({path,},() => {
          if(index){
            that.$store.commit('setProductCurrent',index)
          }
        });
      } else {
        window.open('https://www.chinacamel.com/#/index','_blank')
      }
    },
    toPath(url){
      window.location.href = url
    },
    IsPhone() {
      //获取浏览器navigator对象的userAgent属性（浏览器用于HTTP请求的用户代理头的值）
      var info = navigator.userAgent;
      // navigator.userAgent.indexOf('mobile')
      //通过正则表达式的test方法判断是否包含“Mobile”字符串
      var isPhone = /mobile/i.test(info);
      //如果包含“Mobile”（是手机设备）则返回true
      return isPhone;
    }
  },
};
</script>
<style lang="scss" scoped>
.footer-box {
  position: relative;
  width: 100%;
  height: 4.86rem;
  display: flex;
  background: #000000;
  .left-box {
    // width: calc(100% - 6.4rem);
    // height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    padding-left: 2.1rem;
    padding-top: 0.72rem;
    padding-right: 1rem;
    box-sizing: border-box;
    .cell-big-box{
      width: 100%;
      display: flex;
      justify-content: space-between;
      border-top: 0.01rem solid #666666;
      border-bottom: 0.01rem solid #666666;
      padding-top: 0.3rem;
      padding-bottom: 0.42rem;
      .cell-box {
        // width: 1.84rem;
        text-align: left;
        .title {
          margin-bottom: 0.21rem;
          font-family: SourceHanSansCN-Medium;
          font-size: 0.18rem;
          color: #ffffff;
          line-height: 0.18rem;
        }
        .line {
          margin-top: 0.2rem;
          margin-bottom: 0.25rem;
          width: 0.28rem;
          height: 0.02rem;
          background: #ef0000;
        }
        .text {
          white-space: nowrap;
          font-family: SourceHanSansCN-Regular;
          font-size: 0.14rem;
          color: #ffffff;
          line-height: 0.3rem;
          cursor: pointer;
          transition-duration: 0.5s;
        }
        .text:hover {
          color: #ef0000;
        }
      }

    }
    .copy-right{
      margin-top: 0.3rem;
      font-size: 0.12rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #DFDFDF;
      letter-spacing: 0.002rem;
      line-height: 0.14rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span{
        display: flex;
        align-items: center;
      }
      img{
        margin-right: 0.04rem;
        width: 0.2rem;
        height: 0.2rem;
      }
    }
  }
  .right-box {
    // position: absolute;
    // right: 0;
    // top: 0;
    width: 6.4rem;
    height: 4.86rem;
    // background: url("~@/assets/footer/right-bg.webp") no-repeat;
    // background-size: 100% 100%;
    background: #EF0012;
    text-align: left;
    .logo {
      margin-left: 1rem;
      margin-top: 0.89rem;
      width: 3.01rem;
      height: 0.73rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .card-box {
      position: relative;
      margin-left: 1rem;
      margin-top: 0.25rem;
      display: flex;
      .img {
        width: 0.48rem;
        height: 0.48rem;
        cursor: pointer;
      }
      .img1 {
        background: url("~@/assets/footer/icon-1-1.webp") no-repeat;
        background-size: 100% 100%;
        transition-duration: 0.5s;
      }
      .img2 {
        background: url("~@/assets/footer/icon-2-1.webp") no-repeat;
        background-size: 100% 100%;
        transition-duration: 0.5s;
      }
      .img3 {
        background: url("~@/assets/footer/icon-3-1.webp") no-repeat;
        background-size: 100% 100%;
        transition-duration: 0.5s;
      }
      .img4 {
        background: url("~@/assets/footer/icon-4-1.webp") no-repeat;
        background-size: 100% 100%;
        transition-duration: 0.5s;
      }
      .img5 {
        background: url("~@/assets/footer/icon-5-1.webp") no-repeat;
        background-size: 100% 100%;
        transition-duration: 0.5s;
      }
      .img + .img {
        margin-left: 0.18rem;
      }
      .img-hover-box{
        position: absolute;
        opacity: 0;
        transition-duration: 0.5s;
        .sanjiao{
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          top: -0.1rem;
          width: 0.2rem;
          height: 0.1rem;
        }
        .code{
          width: 1.58rem;
          height: 1.58rem;
        }
      }
      .img-hover-box1{
        top: 0.78rem;
        left: -0.55rem;
      }
      .img-hover-box2{
        top: 0.78rem;
        left: 0.12rem;
      }
      .img-hover-box3{
        top: 0.78rem;
        left: 0.76rem;
      }
      .img-hover-box4{
        top: 0.78rem;
        left: 1.44rem;
      }
      .img-hover-box5{
        top: 0.78rem;
        left: 2.1rem;
      }
      .img1:hover {
        background: url("~@/assets/footer/icon-1.webp") no-repeat;
        background-size: 100% 100%;
      }
      .img2:hover {
        background: url("~@/assets/footer/icon-2.webp") no-repeat;
        background-size: 100% 100%;
      }
      .img3:hover {
        background: url("~@/assets/footer/icon-3.webp") no-repeat;
        background-size: 100% 100%;
      }
      .img4:hover {
        background: url("~@/assets/footer/icon-4.webp") no-repeat;
        background-size: 100% 100%;
      }
      .img5:hover {
        background: url("~@/assets/footer/icon-5.webp") no-repeat;
        background-size: 100% 100%;
      }
      .img1:hover ~ .img-hover-box1{
        opacity: 1;
      }
      .img2:hover ~ .img-hover-box2{
        opacity: 1;
      }
      .img3:hover ~ .img-hover-box3{
        opacity: 1;
      }
      .img4:hover ~ .img-hover-box4{
        opacity: 1;
      }
      .img5:hover ~ .img-hover-box5{
        opacity: 1;
      }
    }
  }
}



.footer-box-app{
  display: none;
}
@media screen and (max-width: 768px){
  .footer-box{
    display: none;
  }
  .footer-box-app{
    width: 100vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #141414;
    .logo-box{
      width: 100%;
      height: 0.6rem;
      background: #E60012;
      img{
        width: 1.53rem;
        height: 0.41rem;
      }
    }
    .copy-right{
      padding: 0 0.2rem;
      padding-bottom: 0.6rem;
      width: 100%;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: #141414;
      .icon-box{
        position: relative;
        padding: 0.2rem 0.22rem;
        width: 100%;
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        border-bottom: 1px solid #ffffff;
        .icon{
          width: 0.4rem;
          height: 0.4rem;
        }
        .img-hover-box{
          position: absolute;
          top: 0.7rem;
          height: 0;
          opacity: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          transition-duration: 0.3s;
          overflow: hidden;
          .sanjiao{
            width: 0.2rem;
            height: 0.1rem;
          }
          .code{
            margin-top: -0.01rem;
            width: 1.2rem;
            height: 1.2rem;
          }
        }
        .img-hover-box1{
          left: -0.17rem;
        }
        .img-hover-box2{
          left: 0.45rem;
        }
        .img-hover-box3{
          left: 1.08rem;
        }
        .img-hover-box4{
          left: 1.71rem;
        }
        .img-hover-box5{
          left: 2.3rem;
        }
        .icon1:hover ~ .img-hover-box1{
          opacity: 1;
          height: 1.3rem;
        }
        .icon2:hover ~ .img-hover-box2{
          opacity: 1;
          height: 1.3rem;
        }
        .icon3:hover ~ .img-hover-box3{
          opacity: 1;
          height: 1.3rem;
        }
        .icon4:hover ~ .img-hover-box4{
          opacity: 1;
          height: 1.3rem;
        }
        .icon5:hover ~ .img-hover-box5{
          opacity: 1;
          height: 1.3rem;
        }
        .img-hover-box1:hover{
          opacity: 1;
          height: 1.3rem;
        }
        .img-hover-box2:hover{
          opacity: 1;
          height: 1.3rem;
        }
        .img-hover-box3:hover{
          opacity: 1;
          height: 1.3rem;
        }
        .img-hover-box4:hover{
          opacity: 1;
          height: 1.3rem;
        }
        .img-hover-box5:hover{
          opacity: 1;
          height: 1.3rem;
        }
      }
      .phone{
        margin-top: 0.2rem;
        font-size: 0.11rem;
        font-family: SourceHanSansCN-Regular;
        color: #DFDFDF;
        line-height: 0.13rem;
        span{
          font-size: 0.16rem;
          color: #FFFFFF;
        }
      }
      .text{
        margin-top: 0.12rem;
        font-size: 0.11rem;
        font-family: SourceHanSansCN-Regular;
        color: #DFDFDF;
        line-height: 0.13rem;
        img{
          margin-right: 0.04rem;
          width: 0.11rem;
          height: 0.12rem;
        }
      }
    }
  }
}
</style>